import {removeTime} from '../../../utils/date'

export const JOBS_CLEAR = 'JOBS_CLEAR';


export const CREATE_JOBS_REQUEST = 'CREATE_JOBS_REQUEST';
export const CREATE_JOBS_SUCCESS = 'CREATE_JOBS_SUCCESS';
export const CREATE_JOBS_ERROR = 'CREATE_JOBS_ERROR';

export const TRIGGER_JOBS_REQUEST = 'TRIGGER_JOBS_REQUEST';
export const TRIGGER_JOBS_SUCCESS = 'TRIGGER_JOBS_SUCCESS';
export const TRIGGER_JOBS_ERROR = 'TRIGGER_JOBS_ERROR';

export const createStatusUpdateJob = (params, status) => {
    return {
        type: 'CALL_API',
        types: [CREATE_JOBS_REQUEST, CREATE_JOBS_SUCCESS, CREATE_JOBS_ERROR],
        method: 'post',
        path: `api/job/status`,
        payload: {
            ...params,
            from_date: params.from_date ? removeTime(params.from_date) : null,
            to_date: params.to_date ? removeTime(params.to_date) : null,
            new_status: status
        },
        message: 'Your job has been scheduled, check out the jobs section to see the progress'
    };
};

export const createGenerateNotificationsJob = (params) => {
    return {
        type: 'CALL_API',
        types: [CREATE_JOBS_REQUEST, CREATE_JOBS_SUCCESS, CREATE_JOBS_ERROR],
        method: 'post',
        path: `api/job/letters`,
        payload: {
            ...params,
            from_date: params.from_date ? removeTime(params.from_date) : null,
            to_date: params.to_date ? removeTime(params.to_date) : null,
        },
        message: 'Your job has been scheduled, check out the jobs section to see the progress'
    };
};

export const clearJobs = () => {
    return {type: JOBS_CLEAR}
};

export const triggerJob = (jobId) => {
    return {
        type: 'CALL_API',
        types: [TRIGGER_JOBS_REQUEST, TRIGGER_JOBS_SUCCESS, TRIGGER_JOBS_ERROR],
        method: 'get',
        path: `api/job/${jobId}/cancel`,
        message: 'Your job has been triggered'
    };
};


// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/jobs.js